import type { PlaylistItem } from '@iconik-io/unified-player-core';
import { createAppPlayerContext } from '@iconik-io/unified-player-ui-react';

export type AppPlaylistItemMeta = {
  assetId: string;
  versionId: string | undefined;
  // Image proxy URL usable as a fallback when the PDF original file URL is
  // missing (deleted, or the share disallows downloads).
  // TODO(FE-7071): Remove once PDFs are rendered from proxies only and
  // originals are not loaded for viewing.
  pdfFallbackImageUrl?: string;
};

export type AppPlaylistItem = PlaylistItem<AppPlaylistItemMeta>;

const appPlayerContext = createAppPlayerContext<AppPlaylistItemMeta>();

export const useAppPlayerContext = appPlayerContext.usePlayerContext;

export const AppPlayerContextProvider = appPlayerContext.PlayerContextProvider;
